module.exports = __webpack_public_path__ + "img/input_icon.9374293c.svg";